import { render } from "./HomeGalleryButtonSelect.vue?vue&type=template&id=25a76663"
import script from "./HomeGalleryButtonSelect.vue?vue&type=script&lang=js"
export * from "./HomeGalleryButtonSelect.vue?vue&type=script&lang=js"
script.render = render

export default script